import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const deleteStore = async (storeId: number | string): Promise<any> => {
  const res = await axiosSecure.delete(`${getContextRoot()}/store/${storeId}`);
  return res.data;
};

export default deleteStore;
